import React from "react"
import { Typography, useTheme } from "@material-ui/core"
import { Mail, BriefcaseBusiness } from "lucide-react"
import { canais } from "../../../utils/canais"

const { interno } = canais

export const DadosContato = ({ initialContact }) => {
  const theme = useTheme()

  const showEmpresa = initialContact?.canalTipoId !== interno

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {/* EMAIL */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: showEmpresa ? 17 : 0,
        }}
      >
        <Mail size={24} color={theme.palette.neutral300} />
        <Typography
          variant="body2"
          style={{
            marginLeft: 16,
            fontFamily: "font/family/body",
            fontWeight: 400,
            fontSize: 14,
            color: theme.palette.neutral300,
          }}
        >
          {initialContact?.email || "Sem e-mail cadastrado"}
        </Typography>
      </div>

      {/* EMPRESA */}
      {showEmpresa && (
        <div style={{ display: "flex", alignItems: "center", marginBottom: 17 }}>
          <BriefcaseBusiness size={24} color={theme.palette.neutral300} />
          <Typography
            variant="body2"
            style={{
              marginLeft: 16,
              fontFamily: "font/family/body",
              fontWeight: 400,
              fontSize: 14,
              color: theme.palette.neutral300,
            }}
          >
            {initialContact?.empresa || "Sem empresa cadastrada"}
          </Typography>
        </div>
      )}
    </div>
  )
}
